// Source-level (DOM-free) transformations of the author's composition HTML for natural text
// editing. These operate on `#html` (the single source of truth), so an edit survives serialization
// and later agent revisions.

function escapeRegExp(value: string): string {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function escapeHtmlText(value: string): string {
    return value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

/**
 * Replace the text content of the element with the given `id` (an editable node) with `value`,
 * escaped as plain text. The element's open tag (and all its attributes) and the rest of the
 * document are preserved — a targeted edit, not a reserialize. Throws if no element has the id.
 */
export function replaceEditableText(html: string, id: string, value: string): string {
    const escapedId = escapeRegExp(id);
    const element = new RegExp(
        `(<([a-zA-Z][\\w-]*)\\b[^>]*\\bid\\s*=\\s*(?:"${escapedId}"|'${escapedId}')[^>]*>)[\\s\\S]*?(</\\2>)`,
        'i',
    );
    if (!element.test(html)) {
        throw new Error(`replaceEditableText: no element with id="${id}"`);
    }
    return html.replace(element, (_match, openTag, _tagName, closeTag) => {
        return `${openTag}${escapeHtmlText(value)}${closeTag}`;
    });
}
